import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
  header: {
    "& th": {
      backgroundColor: "#5D1CE3",
      fontSize: "12px",
      lineHeight: "13px",
      textTransform: "capitalize",
      fontWeight: "normal",
      color: "white",
    },

    "& .breakdownCol": {
      width: "80px",
    },
  },
}));

export default useStyles;
